export default __webpack_public_path__ + "c5f5378f590c3c19ed4f527649ddb76b.svg";